import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, Pipe, Input } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { GetMediaCenterForViewDto, GetNewsForViewDto, MediaLibraryServiceProxy } from '@shared/service-proxies/service-proxies';
import { DateTime } from 'luxon';
import { result } from 'lodash-es';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ImportantNews',
  templateUrl: './ImportantNews.component.html',
  styleUrls: ['./ImportantNews.component.scss'],
  animations: [appModuleAnimation()]
})
export class ImportantNewsComponent extends AppComponentBase implements OnInit {

  @Input() newsitemView: GetMediaCenterForViewDto
  ImageData;
  isImage: boolean = true;
  constructor(injector: Injector,
    private _mediaLibraryProxy: MediaLibraryServiceProxy,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _sinit: DomSanitizer
  ) {
    super(injector);
  }

  ngOnInit() {
    let images = this.newsitemView?.imageAttachmentUrls;
  let videos = this.newsitemView?.vidioAttachmentUrls;

  // Convert to arrays safely
  const imageList = images ? images.split(',').filter(x => x) : [];
  const videoList = videos ? videos.split(',').filter(x => x) : [];

  if (imageList.length > 0) {
    this.ImageData = imageList[0];
    this.isImage = true;
  } else if (videoList.length > 0) {
    this.ImageData = videoList[0];
    this.isImage = false;
  } else {
    this.ImageData = '/assets/common/images/carousel-01.png';
    this.isImage = true;
  }
  }
  goToNews(newsId) {
     this._router.navigate(['media-center/view', newsId]);

  }
}
